module.exports = __webpack_public_path__ + "static/images/callout_3.c386a9e33007273638e36de048fbe5dd.jpg";